import { useState } from "react";
import axiosInstance from "./axiosInstance";

// const defaults = {
//   uploadFileOptions: {
//     method: 'put',q
//   },
//   resultPath: {
//     root: 'signFileUrl', // Note that this is not used in REST hook
//     fileUrl: 'fileUrl',
//     signedUrl: 'signedUrl',
//   },
// };

const useUpload = (uploadEndpoint, options = {}) => {
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    setUploading(true);

    let formData = new FormData();
    formData.append('file', file);
    formData.append("type", options.type);
    const { data } = await axiosInstance.post(uploadEndpoint || '/post', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        setProgress(() => Math.round((100 * progressEvent.loaded) / progressEvent.total - 5));
      },
    });
    setUploading(false);
    data.attachment = data.result.url
    formData.append('attachment', data.attachment);

    return data;
  };
  return { upload, progress, uploading };
};

export default useUpload;
